import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildingsInspection_alerts = z.any()
export type TagsGetBuildingsInspection_alerts = z.infer<typeof tagsGetBuildingsInspection_alerts>

export const querystringGetBuildingsInspection_alerts = z.object({ "buildingId": z.string().uuid().optional() })
export type QuerystringGetBuildingsInspection_alerts = z.infer<typeof querystringGetBuildingsInspection_alerts>

export const responseGetBuildingsInspection_alerts = z.object({ "payload": z.array(z.object({ "inspectionId": z.string(), "buildingId": z.string(), "buildingName": z.string(), "inspectionName": z.string(), "templateKey": z.string().optional(), "dueDate": z.string(), "daysUntilDue": z.number(), "reminderLeadDays": z.number(), "alertType": z.enum(["DUE_SOON","OVERDUE"]), "title": z.string(), "message": z.string(), "actionPath": z.string() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildingsInspection_alerts = z.infer<typeof responseGetBuildingsInspection_alerts>

interface IGetBuildingsInspection_alerts extends BaseMethodType {
  tags: TagsGetBuildingsInspection_alerts,
  querystring: QuerystringGetBuildingsInspection_alerts,
  response: ResponseGetBuildingsInspection_alerts
}
export const URL = '/buildings/inspection-alerts'
export const validation = {
  get: {
    tags: tagsGetBuildingsInspection_alerts,
    querystring: querystringGetBuildingsInspection_alerts,
    response: responseGetBuildingsInspection_alerts
  }
}
export interface BuildingsInspection_alerts extends BaseRouteType {
  get: IGetBuildingsInspection_alerts
}